module.exports = __webpack_public_path__ + "static/media/settings-icon-active.8e675775.svg";